"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverBody: function() {
        return _index.TeachingPopoverBody;
    },
    renderTeachingPopoverBody_unstable: function() {
        return _index.renderTeachingPopoverBody_unstable;
    },
    teachingPopoverBodyClassNames: function() {
        return _index.teachingPopoverBodyClassNames;
    },
    useMediaStyles: function() {
        return _index.useMediaStyles;
    },
    useTeachingPopoverBodyStyles_unstable: function() {
        return _index.useTeachingPopoverBodyStyles_unstable;
    },
    useTeachingPopoverBody_unstable: function() {
        return _index.useTeachingPopoverBody_unstable;
    }
});
const _index = require("./components/TeachingPopoverBody/index");
